import React from 'react';

/**
 * Optiver-themed button. Variants: primary (navy/white adaptive via tokens),
 * accent (#ff3300, use sparingly), ghost (outline), subtle (secondary surface).
 * Sizes: sm | md | lg. Hover/active derive from color-mix in ui.css.
 */
export function Button({
  variant = 'primary',
  size = 'md',
  type = 'button',
  disabled = false,
  className = '',
  children,
  ...rest
}) {
  const classes = [
    'opt-btn',
    `opt-btn--${variant}`,
    `opt-btn--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} disabled={disabled} {...rest}>
      {children}
    </button>
  );
}

export default Button;
